module.exports = __webpack_public_path__ + "img/thumbnail_Reindeer_m_normal.9a61d80e.png";